import { isCustomUI } from './isCustomUI';
import { fg } from '@atlaskit/platform-feature-flags';
export var getExtensionType = function getExtensionType(extension) {
  var properties = extension.properties;
  var enableInlineMacroForCustomUI = fg('platform-enable-inline-macro-for-custom-ui');
  if ((properties === null || properties === void 0 ? void 0 : properties.bodyType) === 'rich-text') {
    return 'bodiedExtension';
  } else if ((properties === null || properties === void 0 ? void 0 : properties.layout) === 'inline' && (!isCustomUI(extension) || enableInlineMacroForCustomUI)) {
    return 'inlineExtension';
  }
  return 'extension';
};